import { PointInfo } from "../../WalltoFittingInfo";
import { WallGrid } from "../WallGrid";

/**
 * 短い壁の補正
 * */
export class SmallWallDelete extends WallGrid {

    private threshold = 0;

    constructor(public pointList: PointInfo[]) {
        super(pointList);
    }

    // 小さい壁の削除 length: 単位mm
    public execute(): PointInfo[] {
        for (let i = 0; i < this.pointList.length; i+=2) {
            const start = this.pointList[i].point.clone();
            const end = this.pointList[i+1].point.clone();
            const width = end.sub(start).length();
            if (width < this.threshold / 1000) {
                this.pointList[i].isDelete = true;
                this.pointList[i+1].isDelete = true;
                const indexList1 = this.clockwiseData[this.indexToGridList[i+1]];
                if (indexList1.length > 0) indexList1.forEach((j: number) => this.pointList[j].point.set(this.pointList[i].point.x, this.pointList[i].point.y, this.pointList[i].point.z));
            }
        }
        return this.pointList;
    }

    public length(e: number) {
        this.threshold = e;
    }
}